import { CONTRACT_MODEL } from '@/helpers/constants'

const normalizeKey = value =>
  value
    ? value
        .toString()
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9.]/g, '')
    : null

const collectProductKeys = product => {
  const keys = new Set()

  const add = value => {
    const normalized = normalizeKey(value)
    if (normalized) {
      keys.add(normalized)
    }
  }

  add(product.id)
  add(product.desc_key)

  if (Array.isArray(product.aliasList)) {
    product.aliasList.forEach(add)
  }

  if (Array.isArray(product.zoneList)) {
    product.zoneList.forEach(zone => {
      add(zone.desc_key)
      if (Array.isArray(zone.aliasList)) {
        zone.aliasList.forEach(add)
      }
    })
  }

  return Array.from(keys)
}

const PT_NEXUS_PRODUCT_CHARACTERISTICS = [
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_10H',
      'PRODUCT_10H',
      'TARIFF_STANDARD_10H',
      'C10',
      '10H',
      'CTT10H',
      'C.PENINSULAR',
    ],
    productLabel: 'CTT 10h (10H)',
    offerLabel: 'B2B',
    lines: [
      '• Fluxo: PT Continente > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volumen: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais CTT 10h (10H): Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS.',
    ],
  },
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_13H',
      'PRODUCT_13H',
      'TARIFF_STANDARD_13H',
      'C14',
      '13H',
      '14H',
      'CTT14H',
      'CTT14H14M',
      'C.ESPAÑA',
    ],
    productLabel: 'CTT 14h (13h), CTT 14hM (13M)',
    offerLabel: 'B2B',
    lines: [
      '• Fluxo: PT Continente > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica a definir de acordo com o meio de transporte utilizado.',
      '• Serviços Adicionais CTT 14h (13H): Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental) / CTT 14hM (13M): Cobrança, Proteção Extra, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).',
    ],
  },
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_24H',
      'PRODUCT_24H',
      'TARIFF_STANDARD_24H',
      'C24',
      '19H',
      'CTT24H',
      '24H',
      'C.PENINSULARPLUS',
      'JSON_PENINSULARPLUS',
    ],
    productLabel: 'CTT 24h (19H), 24hM (19M)',
    offerLabel: 'B2B',
    lines: [
      '• Fluxo: PT Continente > PT Continente; PT Continente > ES Península.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não deve exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais CTT 24h (19H): Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental) / CTT 24hM (19M): Cobrança, Proteção Extra, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).',
    ],
  },
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_48H',
      'PRODUCT_48H',
      'TARIFF_STANDARD_48H',
      'C48',
      'CTT48H',
      '48H',
      'C.PORTUGAL',
      'JSON_PORTUGAL',
    ],
    productLabel: 'CTT 48h (48H)',
    offerLabel: 'B2B',
    lines: [
      '• Fluxo: PT Continente > PT Continente; PT Continente > ES Península.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais CTT 48h (48H): Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), SMS, Sábado (Portugal Continental).',
    ],
  },
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_E24H',
      'PRODUCT_E24H',
      'TARIFF_STANDARD_E24H',
      'CE24',
      'E24H',
      'CTTE24H',
      'C.B2C',
    ],
    productLabel: 'CTT e24h (Para Amanhã)',
    offerLabel: 'B2C',
    lines: [
      '• Fluxo: PT Continente > PT Continente; PT Continente > ES Península.',
      '• Fluxo: ES Península > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não deve exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais CTT e24h (Para Amanhã): Cobrança, Proteção Extra, Back, DDA, Frágil (Portugal Continental), Janelas de Entrega (Portugal Continental), Entrega Conjunta, Alteração Dados da Encomenda, Tentativas de Entrega, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).',
      '• Serviços Adicionais Devolução Fácil: Proteção Extra.',
    ],
  },
  {
    matchers: [
      'PRODUCT_TARIFF_STANDARD_E48H',
      'PRODUCT_E48H',
      'TARIFF_STANDARD_E48H',
      'CE48',
      'E48H',
      'CTTE48H',
      'C.B2C48',
    ],
    productLabel: 'CTT e48h (Em 2 Dias)',
    offerLabel: 'B2C',
    lines: [
      '• Fluxo: PT Continente > PT Continente; PT Continente > ES Península.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica de 167 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais CTT e48h (Em 2 Dias): Cobrança, Proteção Extra, Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).',
    ],
  },
  {
    matchers: [
      'CPT24_RAA',
      'CPT24_LPMA',
      'PRODUCT_CPT24_RAA',
      'PRODUCT_CPT24_LPMA',
      'TARIFF_STANDARD_CPT24_RAA',
      'TARIFF_STANDARD_CPT24_LPMA',
    ],
    productLabel: 'CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados B2C: e24h (Para Amanhã), Devolução Fácil.',
      '• Fluxo principal: PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
      '• Fluxo Devolução Fácil: PT Açores, PT Madeira > PT Continente.',
      '• Peso máximo por volume: Madeira 20 kg; Açores 5 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 167 kg/m3 (meio de transporte aéreo).',
      '• Serviços Adicionais CTT 24h (19H): Cobrança, Proteção Extra, Back, DDA, SMS / CTT 24hM (19M): Cobrança, Proteção Extra, DDA, SMS.',
      '• Serviços Adicionais e24h (Para Amanhã): Cobrança, Proteção Extra, Back, DDA, Alteração Dados da Encomenda, Entrega Conjunta, 2 Tentativas de Entrega, Entrega em Ponto Collectt (A maior rede de pontos Ibérica).',
      '• Serviços Adicionais Devolução Fácil: Proteção Extra.',
    ],
  },
  {
    matchers: [
      'CPT48',
      'PRODUCT_CPT48',
      'TARIFF_STANDARD_CPT48',
    ],
    productLabel: 'CTT 48h, e48h (Em 2 Dias)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados: CTT 48h, e48h (Em 2 Dias).',
      '• Fluxo: PT Continente > PT Açores, PT Madeira; PT Açores, PT Madeira > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 333 kg/m3 (meio de transporte marítimo).',
      '• Serviços Adicionais CTT 48h (48H): Cobrança, Proteção Extra, Back, DDA, SMS.',
      '• Serviços Adicionais e48h (Em 2 Dias): Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.',
    ],
  },
  {
    matchers: [
      'CBA24',
      'PRODUCT_CBA24',
      'TARIFF_STANDARD_CBA24',
    ],
    productLabel: 'CTT 24h (19H), CTT 24hM (19M), CTT e24h (Para Amanhã)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados B2C: CTT e24h (Para Amanhã), Devolução Fácil.',
      '• Fluxo principal: PT Continente > ES Baleares.',
      '• Fluxo Devolução Fácil: ES Baleares > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 167 kg/m3 (meio de transporte aéreo).',
      '• Serviços Adicionais CTT 24h (19H): Cobrança, Proteção Extra, Back, DDA, SMS / CTT 24hM (19M): Cobrança, Proteção Extra, DDA, SMS.',
      '• Serviços Adicionais CTT e24h (Para Amanhã): Cobrança, Proteção Extra, Back, DDA, Alteração Dados da Encomenda, Entrega Conjunta, 2 Tentativas de Entrega.',
      '• Serviços Adicionais Devolução Fácil: Proteção Extra.',
    ],
  },
  {
    matchers: [
      'CBA48',
      'PRODUCT_CBA48',
      'TARIFF_STANDARD_CBA48',
    ],
    productLabel: 'CTT 48h, e48h (Em Dois Dias)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados: CTT 48h, e48h (Em Dois Dias).',
      '• Fluxo: PT Continente > ES Baleares.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 333 kg/m3 (meio de transporte marítimo).',
      '• Serviços Adicionais CTT 48h (48H): Cobrança, Proteção Extra, Back, DDA, SMS.',
      '• Serviços Adicionais CTT e48h (Em Dois Dias): Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.',
    ],
  },
  {
    matchers: [
      'CCA24',
      'PRODUCT_CCA24',
      'TARIFF_STANDARD_CCA24',
    ],
    productLabel: 'CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados B2C: CTT e24h (Para Amanhã), Devolução Fácil.',
      '• Fluxo principal: PT Continente > ES Canárias.',
      '• Fluxo Devolução Fácil: ES Canárias > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Despacho Único Aduaneiro (DUA): disponível para destinos com sistema alfandegário; aos valores indicados na tabela acresce a taxa de 22,50€.',
      '• Cubicagem: conversão volumétrica 167 kg/m3 (meio de transporte aéreo).',
      '• Serviços Adicionais CTT 24h (19H): Cobrança, Proteção Extra, Back, DDA, SMS / CTT 24hM (19M): Cobrança, Proteção Extra, DDA, SMS.',
      '• Serviços Adicionais CTT e24h (Para Amanhã): Cobrança, Proteção Extra, Back, DDA.',
      '• Serviços Adicionais Devolução Fácil: Proteção Extra.',
    ],
  },
  {
    matchers: [
      'CCA48',
      'PRODUCT_CCA48',
      'TARIFF_STANDARD_CCA48',
    ],
    productLabel: 'CTT 48h, e48h (Em Dois Dias)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados: CTT 48h, e48h (Em Dois Dias).',
      '• Fluxo: PT Continente > ES Canárias.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 333 kg/m3 (meio de transporte marítimo).',
      '• Serviços Adicionais CTT 48h (48H): Cobrança, Proteção Extra, Back, DDA, SMS.',
      '• Serviços Adicionais CTT e48h (Em Dois Dias): Cobrança, Proteção Extra, 2 Tentativas de Entrega, Alteração Dados da Encomenda, Entrega Conjunta.',
    ],
  },
  {
    matchers: [
      'C24_OTHER',
      'PRODUCT_C24_OTHER',
      'TARIFF_STANDARD_C24_OTHER',
    ],
    productLabel: 'CTT 24h (19H), CTT 24hM (19M), e24h (Para Amanhã)',
    offerLabel: 'B2B, B2C',
    lines: [
      '• Produtos associados B2C: CTT e24h (Para Amanhã), Devolução Fácil.',
      '• Fluxo principal: PT Continente > Ceuta, Melilla, Gibraltar.',
      '• Fluxo Devolução Fácil: Ceuta, Melilla, Gibraltar > PT Continente.',
      '• Peso máximo por volume: 30 kg.',
      '• Medidas máximas por volume: a soma da altura, largura e comprimento não pode exceder 240 cm, com nenhuma das dimensões superiores a 150 cm.',
      '• Medidas mínimas por volume: comprimento igual ou superior a 22 cm e largura igual ou superior a 15 cm.',
      '• Cubicagem: conversão volumétrica 167 kg/m3 (meio de transporte aéreo).',
      '• Despacho Único Aduaneiro (DUA): disponível para destinos com sistema alfandegário; aos valores indicados na tabela acresce a taxa de 22,50€.',
      '• Serviços Adicionais CTT 24h (19H): Cobrança, Proteção Extra, Back, DDA, SMS / CTT 24hM (19M): Cobrança, Proteção Extra, DDA, SMS.',
      '• Serviços Adicionais CTT e24h (Para Amanhã): Cobrança, Proteção Extra.',
      '• Serviços Adicionais Devolução Fácil: Proteção Extra.',
    ],
  },
  {
    matchers: [
      'CCAR',
      'PRODUCT_CCAR',
      'TARIFF_STANDARD_CCAR',
      'TARIFF_STANDARD_CCAR_PT',
    ],
    productLabel: 'Carga (CCAR)',
    offerLabel: 'B2B',
    lines: [
      '• Fluxo: PT Continente > PT Continente.',
      '• Pesos máximos: Volume 30 kg; Palete 1000 kg; Remessa 5000 kg.',
      '• Unidades máximas por remessa: Volume 999 unidades; Palete 10 unidades.',
      '• Dimensões máximas: Volume 120 x 60 x 60 cm; Palete 120 x 120 x 180 cm.',
      '• Dimensões máximas não cintável: Volume 200 x 120 x 80 cm.',
      '• Dimensões mínimas: Volume 15 x 11 x 3,5 cm.',
      '• Cubicagem: conversão volumétrica 250 kg/m3 (meio de transporte terrestre).',
      '• Serviços Adicionais Carga: Cobrança, DDA.',
      '• Nota: existem destinos em que o prazo de entrega é de 2 dias úteis.',
    ],
  },
]

const ES_2025_PRODUCT_CHARACTERISTICS = [
  {
    matchers: [
      '24H',
      'PRODUCT_24H',
      'TARIFF_STANDARD_24H',
      'CTT24H',
      '24H',
    ],
    productLabel: 'CTT 24h; CTT e24h',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
      '• Cubicaje: Conversión volumétrica 167kg/m3.',
      '• Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de Entrega Prevista, Entrega Hoy y Entregado, además de la Gestión Proactiva de Localización en caso de ausencia del destinatario o dirección incorrecta.',
      '• Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) sin coste adicional.',
    ],
  },
  {
    matchers: [
      'C14E',
      'PRODUCT_C14E',
      'TARIFF_STANDARD_C14E',
    ],
    productLabel: 'CTT Premium Empresas 14h',
    offerLabel: 'B2B',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
      '• Cubicaje: Conversión volumétrica 167kg/m3.',
      '• Cobertura: Capitales de provincia o ciudades de más de 100.000 habitantes y poblaciones a menos de 15 Km de nuestra delegación de destino sin coste adicional. Resto de poblaciones 24h.',
      '• Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de Entrega Prevista, Entrega Hoy y Entregado, además de la Gestión Proactiva de Localización en caso de ausencia del destinatario o dirección incorrecta.',
      '• Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) sin coste adicional.',
    ],
  },
  {
    matchers: [
      '13h',
      '13H',
      '14H',
      'PRODUCT_13H',
      'TARIFF_STANDARD_13H',
      'CTT14H',
    ],
    productLabel: 'CTT 14h',
    offerLabel: 'B2B',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
      '• Cubicaje: Conversión volumétrica 167kg/m3.',
      '• Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de Entrega Prevista, Entrega Hoy y Entregado, además de la Gestión Proactiva de Localización en caso de ausencia del destinatario o dirección incorrecta.',
      '• Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) sin coste adicional.',
    ],
  },
  {
    matchers: [
      '10h',
      '10H',
      'PRODUCT_10H',
      'TARIFF_STANDARD_10H',
      'CTT10H',
    ],
    productLabel: 'CTT 10h',
    offerLabel: 'B2B',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
      '• Cubicaje: Conversión volumétrica 167kg/m3.',
      '• Cobertura: Capitales de provincia o ciudades de más de 100.000 habitantes y poblaciones a menos de 15 Km de nuestra delegación de destino sin coste adicional. El resto de las poblaciones, llevarán un suplemento por km adicional a partir de 15 km de nuestra delegación más próxima (30 km ida y vuelta) y se incrementará en 1 minuto el compromiso de entrega, por cada km adicional desde esos 15 km de distancia (consultar en la www.cttexpress.com/suplementos poblaciones con suplemento de kilometraje).',
      '• Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de Entrega Prevista, Entrega Hoy y Entregado, además de la Gestión Proactiva de Localización en caso de ausencia del destinatario o dirección incorrecta.',
      '• Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) sin coste adicional.',
    ],
  },
  {
    matchers: [
      '48h',
      '48H',
      'PRODUCT_48H',
      'TARIFF_STANDARD_48H',
      'CTT48H',
    ],
    productLabel: 'CTT 48h; CTT e48h',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm.',
      '• Cubicaje: Conversión volumétrica 167kg/m3.',
      '• Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
      '• Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de Entrega Prevista, Entrega Hoy y Entregado, además de la Gestión Proactiva de Localización en caso de ausencia del destinatario o dirección incorrecta.',
      '• Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) sin coste adicional.',
    ],
  },
  {
    matchers: [
      'CANEXPRESS',
      'CANECOMMERCE',
      'PRODUCT_CANEXPRESS',
      'PRODUCT_CANECOMMERCE',
    ],
    productLabel: 'CTT Canarias Aéreo',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
      '• Cubicaje: Conversión volumétrica 167kg/m3 aéreo.',
      '• CTT Canarias Documentación: Entrega en 24h. Servicio válido solo para envíos de documentación.',
      '• CTT Canarias Aéreo: Entrega en 48h TLF y LPA y 72h Islas Menores. Incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
    ],
  },
  {
    matchers: [
      'CANMARITIMO',
      'PRODUCT_CANMARITIMO',
    ],
    productLabel: 'CTT Canarias Marítimo',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
      '• Cubicaje: Conversión volumétrica 333 kg/m3 marítimo.',
      '• CTT Canarias Marítimo: Entrega en 7 días. El servicio "Islas Mayores" e "Islas Menores" incluye DUA y Trámites de Gestión Aduanera Simplificada (GAS). No incluye el IVA y otros impuestos por el valor declarado.',
    ],
  },
  {
    matchers: [
      'BALEXPRESS',
      'BALECONOMY',
      'PRODUCT_BALEXPRESS',
      'PRODUCT_BALECONOMY',
    ],
    productLabel: 'CTT Baleares',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg.',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
      '• Cubicaje: Conversión volumétrica 167 kg/m3 aéreo y 333 kg/m3 marítimo.',
    ],
  },
  {
    matchers: [
      'OTHERDESTINATIONS',
      'PRODUCT_OTHERDESTINATIONS',
    ],
    productLabel: 'Ceuta, Melilla, Gibraltar, Andorra e Islas Portugal',
    offerLabel: 'B2B; B2C',
    lines: [
      '• Peso máximo por bulto: 30 kg (Islas Portugal Aéreo: Madeira hasta 20kg; Azores hasta 5kg).',
      '• Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
      '• Cubicaje: Conversión volumétrica 167kg/m3 (Ceuta, Melilla e Islas Portugal Marítimo 333 kg/m3).',
      '• Impuestos e IVA no incluidos. Ver página de Servicios Aduaneros.',
      '• Islas Portugal: no es necesario documentación adicional (Territorio intracomunitario).',
    ],
  },
]

const CHARACTERISTICS_BY_MODEL = {
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT]: PT_NEXUS_PRODUCT_CHARACTERISTICS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT_NEXUS]: PT_NEXUS_PRODUCT_CHARACTERISTICS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_PT_NEXUS]: PT_NEXUS_PRODUCT_CHARACTERISTICS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025]: ES_2025_PRODUCT_CHARACTERISTICS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026]: ES_2025_PRODUCT_CHARACTERISTICS,
}

export const getProductCharacteristicsForExcel = (contractModel, product) => {
  if (!contractModel || !product) return null

  const candidates = CHARACTERISTICS_BY_MODEL[contractModel]
  if (!candidates) return null

  const productKeys = collectProductKeys(product)
  if (!productKeys.length) return null

  const match = candidates.find(entry =>
    entry.matchers.some(matcher => {
      const normalizedMatcher = normalizeKey(matcher)
      return normalizedMatcher && productKeys.includes(normalizedMatcher)
    }),
  )

  if (!match) return null

  return {
    offerLabel: match.offerLabel,
    productLabel: match.productLabel,
    lines: [...match.lines],
  }
}
